import { createContext } from 'react';
import type { gameInfoType } from '@/pages/opinion/types/common';

export const FilterGameInfoContext = createContext<{
  gameInfo: gameInfoType;
  use: boolean;
  wholeGameInfo: any;
}>({
  gameInfo: { edition_unified_id: '', entity_type: '', id_type: '' },
  use: false,
  wholeGameInfo: {}
});
